import { useEffect, useState } from 'react';

const STORAGE_KEY = 'sd.cookie.consent';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      setVisible(!v);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (value: 'accepted' | 'rejected') => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-slate-900/95 backdrop-blur border-t border-slate-700 shadow-2xl">
      <div className="max-w-5xl mx-auto px-4 py-3 flex flex-col md:flex-row md:items-center gap-3">
        <div className="text-sm text-slate-200 flex-1">
          Мы используем технические файлы cookie, необходимые для работы Service
          Desk (сессия входа, переключатель темы, состояние очереди и фильтров).
          Аналитические или маркетинговые cookie не устанавливаем.
          Подробнее — в{' '}
          <a href="https://valocloud.ru/documents/policy_iipdn_24.11.2025.docx"
             target="_blank" rel="noreferrer"
             className="text-blue-400 hover:text-blue-300 underline">
            Политике обработки персональных данных
          </a>.
        </div>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => choose('rejected')}
                  className="px-3 py-1.5 text-xs font-bold rounded border border-slate-600 text-slate-300 hover:bg-slate-800">
            Только необходимые
          </button>
          <button onClick={() => choose('accepted')}
                  className="px-3 py-1.5 text-xs font-bold rounded bg-blue-600 hover:bg-blue-500 text-white">
            Принять
          </button>
        </div>
      </div>
    </div>
  );
}
